import FooterMenu, { Props as FooterMenuProps } from '@templates/FooterMenu';
import CopyrightFooter, { Props as CopyrightFooterProps } from '@templates/CopyrightFooter';

type Props = FooterMenuProps & CopyrightFooterProps;

const Footer = ({ menuItems, rewards, brands, logos, apiVersion }: Props): JSX.Element => (
  <>
    {!!menuItems.length && (
      <FooterMenu
        menuItems={menuItems}
        rewards={rewards}
        brands={brands}
        apiVersion={!logos.length ? apiVersion : undefined}
      />
    )}
    {!!logos.length && <CopyrightFooter logos={logos} apiVersion={apiVersion} />}
  </>
);

export default Footer;
